export class CondicionesPago {
    
    public activo: boolean;
    public codpag: number;
    public despag: string;
    public predeterminado: boolean;
    public usuari: string;
    public nombreusuario: string;
    public factua: string;

    public esNuevo: boolean;
}